@if (isBrowser) {
  <div class="container p-0">
    <div class="widget-calculator__wrapper">
      <calc-widget-calculator [site]="theme" [workType]="data.workType"></calc-widget-calculator>
    </div>
  </div>
}
